import CircularProgressBar from "components/common/CircularProgress";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";
import ColorBullet from "../ColorBullet";
import "./NumberSet.scss";

interface Props {
  variant?: "Dark" | "Light";
  backgroundColor?: string;
  title: string;
  snapShot: any;
}

const getActivePlansIcon = (variant: string) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="24" height="24" rx="12" fill={variant === "Dark" ? "white" : "#F6F5F3"} />
    <g clipPath="url(#clip0_15498_200664)">
      <path
        d="M7.99976 8.5H9.99976M7.99976 11H12.4998M16.4998 11L13.4998 16L9.99976 14L7.99976 17M17.4998 19H6.49976C5.94747 19 5.49976 18.5523 5.49976 18V7C5.49976 6.44771 5.94747 6 6.49976 6H17.4998C18.052 6 18.4998 6.44771 18.4998 7V18C18.4998 18.5523 18.052 19 17.4998 19Z"
        stroke="#4D4745"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_15498_200664">
        <rect width="14" height="14" fill="white" transform="translate(5 5.5)" />
      </clipPath>
    </defs>
  </svg>
);

function NumberSet(props: Props) {
  const { variant = "default", title, snapShot } = props;

  const getCustomLayout = () => {
    return (
      <div className={`numberSet ${variant}`}>
        <div className="numberSet-left">
          <Typography
            variant="body2"
            showBold
            color={variant === "Dark" ? tokens.Text.General.Inverse : tokens.Text.General.Secondary}
          >
            Active {title}
          </Typography>
          <Typography
            variant="h4"
            showBold
            color={variant === "Dark" ? tokens.Text.General.Inverse : tokens.Text.General.Secondary}
            className="numberSet-left-image"
          >
            {getActivePlansIcon(variant)} {snapShot.active || 0}
          </Typography>
        </div>
        <div className="numberSet-right">
          <div className="numberSet-right-details">
            <div className="numberSet-right-details-item">
              <ColorBullet color="overdue" />
              <Typography
                variant="label"
                showBold
                color={variant === "Dark" ? tokens.Text.General.Inverse : tokens.Text.General.Secondary}
              >
                {snapShot.overdue || 0}
              </Typography>
              <Typography
                variant="label"
                color={variant === "Dark" ? tokens.Text.General.Inverse : tokens.Text.General.Secondary}
              >
                Overdue
              </Typography>
            </div>
            <div className="numberSet-right-details-item">
              <ColorBullet color="completed" />
              <Typography
                variant="label"
                showBold
                color={variant === "Dark" ? tokens.Text.General.Inverse : tokens.Text.General.Secondary}
              >
                {snapShot.completedLast90Days || 0}
              </Typography>
              <Typography
                variant="label"
                color={variant === "Dark" ? tokens.Text.General.Inverse : tokens.Text.General.Secondary}
              >
                *Completed
              </Typography>
            </div>
          </div>
          <CircularProgressBar
            variant={variant}
            strokeWidth={8}
            tooltipCompleted={`Completed: ${snapShot.completedLast90Days}`}
            tooltipOverdue={`Overdue: ${snapShot.overdue}`}
            tooltipActive={`In Progress: ${snapShot.active - snapShot.overdue}`}
            tooltipCenter={`Total: ${snapShot.completedLast90Days + snapShot.active}`}
            data={{
              completed: snapShot.completedLast90Days,
              overdue: snapShot.overdue,
              active: snapShot.active,
              total: snapShot.completedLast90Days + snapShot.active
            }}
          />
        </div>
      </div>
    );
  };

  return getCustomLayout();
}

export default NumberSet;
